import _ from 'lodash';
import WixEvent from '../../ui/events/WixEvent';
import imageUtils from '../../privates/utils/imageUtils';


function getImageData(event) {
    let image;

    try {
        if (_.get(event, 'item')) {
            image = imageUtils.dataFormat.toUser(event.item);
        }
    } catch (e) {/*do nothing*/
    }

    return image;
}


/**
 * @callback $w.GalleryItemChangedEventHandler
 * @summary Handles events fired when a gallery moves to a new image.
 * @param {$w.GalleryItemChangedEvent} event The event that occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class GalleryItemChangedEvent
 * @summary Event that is fired when a gallery moves to a new image.
 * @memberof $w
 * @mixes $w.Event
 */
export default class GalleryItemChangedEvent extends WixEvent {
    constructor(target, event) {
        super(target, event);

        this.item = getImageData(event);
        this.itemIndex = event.imageIndex;

    }

    /**
     * @member item
     * @label property
     * @syntax
     * get item(): ImageItem | VideoItem
     * @summary Gets the gallery item.
     * @snippet [GalleryEvent-item.es6=Get the event's item]
     * @type {$w.Gallery~ImageItem|$w.Gallery~VideoItem}
     * @memberof $w.GalleryItemChangedEvent
     * @readonly
     */

    /**
     * @member itemIndex
     * @label property
     * @syntax
     * get itemIndex(): Number
     * @summary Gets the gallery item's index.
     * @type {external:Number}
     * @snippet [GalleryEvent-itemIndex.es6=Get the event's item index]
     * @memberof $w.GalleryItemChangedEvent
     * @readonly
     */
}
